(function () {
  if (window.__BREED_RECO_INIT__) return;
  window.__BREED_RECO_INIT__ = true;

  function parseMap(root) {
    const id = root.getAttribute("data-map-id");
    const tag = id && document.getElementById(id);
    if (!tag) return null;
    try { return JSON.parse(tag.textContent || "{}"); } catch { return null; }
  }

  function findProductForm(root) {
    return root.closest('form[action^="/cart/add"]') || document.querySelector('form[action^="/cart/add"]');
  }

  function getCurrentVariantId(root) {
    // 1) Hidden/select input with name="id"
    const form = findProductForm(root);
    let vid = null;
    if (form) {
      const idField = form.querySelector('input[name="id"], select[name="id"]');
      if (idField && idField.value) vid = idField.value;
    }
    // 2) URL ?variant=...
    if (!vid) {
      const qs = new URLSearchParams(location.search);
      const fromUrl = qs.get("variant");
      if (fromUrl) vid = fromUrl;
    }
    // normalize
    if (!vid) return null;
    const n = parseInt(vid, 10);
    return isNaN(n) ? String(vid) : String(n);
  }

  // Only update when something actually changed
  function updateIfChanged(root, map) {
    const labelEl = root.querySelector(".breed-reco__label");
    const textEl  = root.querySelector(".breed-reco__text");
    if (!labelEl || !textEl || !map) return;

    const vid  = getCurrentVariantId(root);
    const size = (vid && map.variant_to_size) ? map.variant_to_size[vid] : null;
    const item = (size && map.items) ? map.items[size] : null;

    const hasText = !!(item && typeof item.text === "string" && item.text.trim().length);
    const text = hasText ? item.text : (map.fallback_text || "No breed recommendation.");

    const prevVid  = root.dataset.brVid || "";
    const prevText = root.dataset.brText || "";
    if (String(vid || "") === prevVid && text === prevText) return; // no change

    // Commit
    root.dataset.brVid  = String(vid || "");
    root.dataset.brText = text;

    labelEl.textContent = map.label || "Breed recommendation";
    textEl.textContent  = text;
    textEl.classList.toggle("is-fallback", !hasText);

    // keep visible while testing
    root.style.display = "block";

    if (map.debug) console.log("[BREED_RECO]", { vid, size, hasText, text });
  }

  function schedule(root, map) {
    if (root.__brScheduled) return;
    root.__brScheduled = true;
    requestAnimationFrame(() => {
      root.__brScheduled = false;
      updateIfChanged(root, map);
    });
  }

  function startPoller(root, map) {
    if (root.__brPoll) return;
    root.__brPoll = setInterval(() => {
      // repaint only if variant id changed since last commit
      const currentVid = getCurrentVariantId(root) || "";
      if (currentVid !== (root.dataset.brVid || "")) {
        schedule(root, map);
      }
    }, 250);
  }

  function stopPoller(root) {
    if (root && root.__brPoll) {
      clearInterval(root.__brPoll);
      root.__brPoll = null;
    }
  }

  function bindOne(root) {
    if (!root || root.dataset.brBound === "1") return;
    root.dataset.brBound = "1";

    const map = parseMap(root);
    if (!map) return;

    const reapply = () => schedule(root, map);

    // Initial paint + start poller
    reapply();
    startPoller(root, map);

    // Hook common interactions (these now just hint the scheduler)
    const form = findProductForm(root);
    if (form) {
      form.addEventListener("change", reapply);
      form.addEventListener("input",  reapply);
      form.addEventListener("click",  reapply);
    }
    document.addEventListener("variant:changed", reapply);
    document.addEventListener("product:variant-change", reapply);
    document.addEventListener("variant:change", reapply);

    // URL changes to ?variant=...
    (function patchHistory(){
      if (window.__BR_HISTORY_PATCHED__) return;
      window.__BR_HISTORY_PATCHED__ = true;
      const push = history.pushState, replace = history.replaceState;
      function fire(){ window.dispatchEvent(new Event("locationchange")); }
      history.pushState = function(){ const r = push.apply(this, arguments); fire(); return r; };
      history.replaceState = function(){ const r = replace.apply(this, arguments); fire(); return r; };
      window.addEventListener("popstate", fire);
    })();
    window.addEventListener("locationchange", reapply);

    // Clean up poller if this block gets removed
    document.addEventListener("shopify:section:unload", () => {
      if (!document.body.contains(root)) stopPoller(root);
    });
  }

  function scan() {
    document.querySelectorAll(".breed-reco").forEach(bindOne);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  document.addEventListener("shopify:section:load", scan);
  document.addEventListener("shopify:section:select", scan);
  document.addEventListener("shopify:block:select", scan);
})();
